import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Card from '../components/Card';
import __ from '../utils/translator';
import PatternCardList from '../components/PatternCardList';
import PageHeader from '../components/PageHeader';
import CardTitle from '../components/CardTitle';
import remToPixels from '../utils/remToPixels';
import PageTitle from '../components/PageTitle';
import ProductFocusStatus from "../components/ProductFocusStatus";
import ProductFocusesStoreActions from "../flux/ProductFocusesStoreActions";
import ProductFocusesStore from "../flux/ProductFocusesStore";
import RenderOnTablet from "../components/responsive/RenderOnTablet";
import Header from '../components/organisms/Header';
import OutletOnlyLabel from "../components/OutletOnlyLabel";
import JwtStore from "../flux/JwtStore";
import NoResults from "../components/NoResults";

function resizeCover(cover) {
  return cover.replace('0x0', `${remToPixels(45)}x${remToPixels(45)}`);
}

class ProductFocuses extends Component {
  state = {
    productFocuses: [],
    isPageLoading: true
  };
  subscriptions = [];

  componentDidMount() {
    ProductFocusesStoreActions.fetch();
    this.setState({
      ...this.state,
      isPageLoading: true
    });
    this.subscriptions.push(ProductFocusesStore.addListener(() => {
      this.setState({
        productFocuses: ProductFocusesStore.getState(),
        isPageLoading: false
      });
    }));
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header />

        <PageTitle withTracking title="Product Focus" />

        <RenderOnTablet>
          <PageHeader
            crumbs={[__('Home'), __('Product Focus')]}
            title={__('Product Focus')} />
        </RenderOnTablet>

        {(!this.state.isPageLoading && this.state.productFocuses.length === 0) && (
          <NoResults message={__('No results for the selected user.')}/>
        )}
        {this.state.productFocuses.length > 0 && (
          <Container>
            <PatternCardList>
              {this.state.productFocuses.map(productFocus => (
                <Card
                  key={productFocus.id}
                  linkTo={`/product-focuses/${productFocus.id}`}
                  cover={resizeCover(productFocus.cover)}
                  justifyContent="flex-end"
                >
                  <CardTitle style={{ textTransform: 'uppercase' }}>{productFocus.name}</CardTitle>
                  <ProductFocusStatus
                    small
                    status={productFocus.status}
                    style={{ marginTop: '.5rem' }}
                  />
                  {JwtStore.hasGlobalVisibility() && productFocus.visibleOnlyForOutlets ? <OutletOnlyLabel /> : null}
                </Card>
              ))}
            </PatternCardList>
          </Container>
        )}
      </div>
    );
  }
}

export default ProductFocuses;

const Container = styled.div`

  ${props => props.theme.isTablet && css`
    background-color: #333;
  `}
`;
